import React from 'react'
import { useCssHandles } from '../hooks/useCssHandles'
import Header from './Header'
import Footer from './Footer'
import { Minicart } from '../../modules/cart/components'
import WhatsAppButton from './WhatsAppButton'

const CSS_HANDLES = [
  'layout',
  'layoutContent',
  'mainContent'
] as const

interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const handles = useCssHandles(CSS_HANDLES)

  return (
    <div className={`${handles.layout} min-h-screen flex flex-col bg-gray-50`}>
      <Header />
      
      <main className={`${handles.mainContent} flex-1`}>
        <div className={`${handles.layoutContent}`}>
          {children}
        </div>
      </main>
      
      <Footer />
      <Minicart />
      <WhatsAppButton />
    </div>
  )
}

export default Layout

